import { create } from 'zustand'

export interface File {
  id: string
  name: string
  url: string
  public_url?: string
  type: string
  size: number
  created_at: string
  updated_at: string
  selected: boolean
  order: number | null
}

interface Store {
  sessionId: string | null
  files: File[]
  expiresAt: string | null
  setSessionId: (sessionId: string) => void
  setFiles: (files: File[] | ((prev: File[]) => File[])) => void
  setExpiresAt: (expiresAt: string | null) => void
  toggleFileSelection: (fileId: string) => void
  updateFileOrder: (fileId: string, order: number) => void
  clearSelection: () => void
}

export const useStore = create<Store>((set) => ({
  sessionId: null,
  files: [],
  expiresAt: null,
  setSessionId: (sessionId) => set({ sessionId }),
  setFiles: (files) => set((state) => ({
    ...state,
    files: typeof files === 'function' ? files(state.files) : files,
  })),
  setExpiresAt: (expiresAt) => set((state) => ({ ...state, expiresAt })),
  toggleFileSelection: (fileId) =>
    set((state) => ({
      files: state.files.map((file) =>
        file.id === fileId
          ? { ...file, selected: !file.selected, order: !file.selected ? null : file.order }
          : file
      ),
    })),
  updateFileOrder: (fileId, order) =>
    set((state) => ({
      files: state.files.map((file) =>
        file.id === fileId ? { ...file, order } : file
      ),
    })),
  clearSelection: () =>
    set((state) => ({
      files: state.files.map((file) => ({ ...file, selected: false, order: null })),
    })),
})) 